// @flow
import React, { useCallback } from 'react';

import CommonPage from 'app/common/templates/CommonPage';

import {
  StatementsLayout,
  StatementInfo,
  StatementAction,
  StatementNew,
  StatementsList,
  StatementsDataContainer,
} from 'app/components/Statements';

import * as statementSections from './statementSections';
import useStatementsTitle from './useStatementsTitle';

/**
 *  Страница родительского контроля
 */

type Props = {
  router: {
    push: (string) => void,
  },
  params: {
    section: string,
    statementId: string,
  },
}

const StatementsPage = ({
  router: { push },
  params: { section, statementId },
}: Props) => {
  const baseUrl = '/statements';
  const [statementTilte, loadingStatementTitle] = useStatementsTitle();

  const handleAddNew = useCallback(() => {
    push(`${baseUrl}/${statementSections.EDIT}/new`);
  }, [push]);

  const handleChangeCurrentStatement = useCallback((newStatementId: number) => {
    push(`${baseUrl}/${statementSections.VIEW}/${newStatementId}`);
  }, [push]);

  const handleFormCancel = useCallback(() => {
    push(`${baseUrl}/${statementSections.VIEW}`);
  }, [push]);

  return (
    <CommonPage header={loadingStatementTitle ? '…' : statementTilte}>
      <StatementsDataContainer>
        <StatementsLayout
          sideTop={
            <StatementAction
              onClick={handleAddNew}
              disabled={section === statementSections.EDIT}
            />
          }
          sideMain={
            <StatementsList
              disabled={section === statementSections.EDIT}
              currentStatementId={statementId}
              onCurrentStatementInvalidate={handleChangeCurrentStatement}
              onStatementClick={handleChangeCurrentStatement}
            />
          }
        >
          {section === statementSections.VIEW
            && !!statementId
            && <StatementInfo statementId={parseInt(statementId, 10)} />}
          {section === statementSections.EDIT
            && statementId === 'new'
            && <StatementNew onCancel={handleFormCancel} />}
        </StatementsLayout>
      </StatementsDataContainer>
    </CommonPage>
  );
};

export default StatementsPage;
